import { Button } from '@pwc/appkit-react';

type ResetLocatorProps = {
  isDisabled: boolean;
  onClick: () => void;
  isLoading: boolean;
};

export const ResetLocatorButton: React.FC<ResetLocatorProps> = ({
  isDisabled,
  onClick,
  isLoading,
}) => {
  return (
    <Button
      size="lg"
      className="add-button"
      disabled={isDisabled}
      onClick={onClick}
      kind="secondary"
      isLoading={isLoading}
    >
      RESET LOCATOR
    </Button>
  );
};
